import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getDrafts, getForms } from "../../Forms/api";
import { fetchServiceRequests } from "../../WindowDoor/ServiceRequests/api";
import { fetchMyFeatureRequests } from "../../../views/FeatureRequests/featureRequestsApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Statuses that still need somebody to do something (mirrors OPEN_STATUSES
// in server/routes/api/WindowDoor/serviceRequests.js).
const OPEN_SERVICE_STATUSES = [
  "Submitted",
  "Homeowner Contacted",
  "Job Quoted",
  "Parts Ordered",
  "Job Completed - Billing Required",
];

const OPEN_FEATURE_STATUSES = ["new", "planned", "in_progress"];

// Cross-form pulse of the user's own submissions — the tile version of the
// My Submissions page, built on the same per-system API helpers.
const MySubmissionsWidget = () => {
  const user = useSelector(selectUser);
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    if (!user?.userID && !user?.email) return;
    let cancelled = false;

    const load = async () => {
      let submitted = [];
      let drafts = [];
      let service = [];
      let features = [];
      await Promise.all([
        getForms((data) => {
          submitted = Array.isArray(data) ? data : [];
        }, user),
        getDrafts((data) => {
          drafts = Array.isArray(data) ? data : [];
        }, user),
        fetchServiceRequests({ scope: "mine", user })
          .then((data) => {
            service = Array.isArray(data) ? data : [];
          })
          .catch(() => {}),
        (user?.email
          ? fetchMyFeatureRequests(user.email)
          : Promise.resolve([])
        )
          .then((data) => {
            features = Array.isArray(data) ? data : [];
          })
          .catch(() => {}),
      ]);
      if (cancelled) return;
      setCounts({
        submitted: submitted.length,
        drafts: drafts.length,
        openService: service.filter((row) =>
          OPEN_SERVICE_STATUSES.includes(row.status)
        ).length,
        openFeatures: features.filter((row) =>
          OPEN_FEATURE_STATUSES.includes(row.status)
        ).length,
      });
    };

    load();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userID, user?.email]);

  return (
    <WidgetFrame title="My Submissions" to="/forms/my-submissions">
      {counts ? (
        <div className="grid grid-cols-2 gap-2">
          <WidgetStat value={counts.submitted} label="RFQs Submitted" />
          <WidgetStat value={counts.drafts} label="Drafts" />
          <WidgetStat value={counts.openService} label="Open Service Req." />
          <WidgetStat value={counts.openFeatures} label="Open Feature Req." />
        </div>
      ) : (
        <WidgetEmpty>Loading your submissions…</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default MySubmissionsWidget;
